import { useQueryParam, StringParam } from 'use-query-params';
export const useSearchString = () => {
  const [searchString] = useQueryParam('search', StringParam);
  if (!searchString?.length) {

    return {};
  }

  try {
    const search = JSON.parse(atob(searchString));

    return {
      searchParameters: search?.searchParameters || {},
      url: search?.url || undefined,
      searchParamString: searchString
    };
  } catch {
    return {};
  }
};